module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"correct":"Correct","next":"Next","submit":"Submit","wrong":"Wrong"},"pt":{"correct":"Correto","next":"Próximo","submit":"Enviar","wrong":"Errado"}}')
  delete Component.options._Ctor
}
